import { ALL_ACTIONS, ALL_ACTOR_KINDS, parseStoredSelection } from "../../components/scheduleChanges/changeFilters";
import { ACTION_FILTER_SESSION_KEY, DEFAULT_ACTION_FILTER, DEFAULT_WHO_FILTER, WHO_FILTER_SESSION_KEY } from "../../components/scheduleChanges/consts";
import type { ScheduleChangeAction, ScheduleChangeActorKind } from "../../components/scheduleChanges/types";
import { useSessionChoice } from "./useSessionChoice";

const serializeSelection = (selection: readonly string[]): string => JSON.stringify(selection);

// Module constants: `useSessionChoice` reads its options once.
const WHO_OPTIONS = {
	key: WHO_FILTER_SESSION_KEY,
	name: "who",
	parse: (raw: string) => parseStoredSelection<ScheduleChangeActorKind>(raw, ALL_ACTOR_KINDS),
	serialize: serializeSelection,
	initial: DEFAULT_WHO_FILTER,
};
const ACTION_OPTIONS = {
	key: ACTION_FILTER_SESSION_KEY,
	name: "action",
	parse: (raw: string) => parseStoredSelection<ScheduleChangeAction>(raw, ALL_ACTIONS),
	serialize: serializeSelection,
	initial: DEFAULT_ACTION_FILTER,
};

export type ChangeFilterChoices = {
	who: readonly ScheduleChangeActorKind[];
	setWho: (next: readonly ScheduleChangeActorKind[]) => void;
	actions: readonly ScheduleChangeAction[];
	setActions: (next: readonly ScheduleChangeAction[]) => void;
};

/**
 * The scheduler's two schedule-changes choices, each kept for the browser session: whose changes (everyone,
 * `DEFAULT_WHO_FILTER`) and what kinds of change (`DEFAULT_ACTION_FILTER`) the side panel's Changes tab lists.
 */
export const useChangeFilterChoices = (): ChangeFilterChoices => {
	const [who, setWho] = useSessionChoice<readonly ScheduleChangeActorKind[]>(WHO_OPTIONS);
	const [actions, setActions] = useSessionChoice<readonly ScheduleChangeAction[]>(ACTION_OPTIONS);
	return { who, setWho, actions, setActions };
};
